<div class="justify-content-center container align-items-center">
    <mat-card>
        <mat-card-content [attr.dir]="dir">
            <div class="justify-content-center align-items-center d-flex" *ngIf="loading">
                <mat-spinner></mat-spinner>
            </div>

            <div *ngIf="contentEntryData && !loading">
                <h3 [innerHTML]="contentEntryData.title" style="margin-top: 5px;"></h3>
                <div [innerHTML]="contentEntryData.body" class="text-wrapper" style="margin-top: 35px;"></div>
            </div>
        </mat-card-content>
    </mat-card>
</div>